/**
 * Per-person forms: earthnode creates one form per person from these templates and names it
 * `<prefix><person's name>` (`VIOOnboardingAppForm::INDIVIDUALS_INFO_FORMS`, e.g. "Signing Authority Jane
 * Doe"). Keyed by template identifier: `prefix` is the English prefix exactly as earthnode writes it, and
 * `templateName` is the template's own English name, which starts with the same prefix.
 */
const PERSON_FORMS: Record<string, { prefix: string; templateName: string }> = {
  signing_authorities: { prefix: 'Signing Authority ', templateName: 'Signing Authority Details' },
  ownership_structure: { prefix: 'Owner ', templateName: 'Ownership Structure Details' },
  trust_structure: { prefix: 'Trust ', templateName: 'Trust Structure Details' },
  key_controller: { prefix: 'Key Controller ', templateName: 'Key Controller Details' },
  partnership_structure: { prefix: 'Partner ', templateName: 'Partnership Structure Details' },
};

/**
 * The person's name in a per-person form's English `Name`, or `null` when the form isn't a per-person
 * one: another template, the template's own name, or a name without the person-form prefix.
 */
export default function getPersonFormName(identifier: string, name: string): string | null {
  const personForm = PERSON_FORMS[identifier];

  if (!personForm || name === personForm.templateName || !name.startsWith(personForm.prefix)) return null;

  return name.slice(personForm.prefix.length).trim() || null;
}
